import {
  faArrowLeft,
  faAnglesLeft,
  faAnglesRight,
  faRightFromBracket,
  faUserCircle,
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Dropdown } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import './Topbar.css';

interface ITopBar {
  onToggleSidebar: () => void;
  sidebarOpen: boolean;
}

export default function TopBar({ onToggleSidebar, sidebarOpen }: ITopBar) {
  const navigate = useNavigate();

  const handleLogout = () => {
    localStorage.removeItem('authKey');
    navigate('/login');
  };

  return (
    <header className="xrg-topbar">
      <div className="d-flex align-items-center gap-2">
        <button
          className="xrg-sidebar-toggle"
          onClick={onToggleSidebar}
          aria-label={sidebarOpen ? 'Collapse sidebar' : 'Expand sidebar'}
        >
          <FontAwesomeIcon icon={sidebarOpen ? faAnglesLeft : faAnglesRight} />
        </button>
        {/* <button
          className="xrg-sidebar-toggle"
          onClick={() => navigate(-1)}
          aria-label="Go back"
        >
          <FontAwesomeIcon icon={faArrowLeft} size="sm" />
        </button> */}
      </div>

      <div className="d-flex align-items-center">
        <Dropdown align="end">
          <Dropdown.Toggle
            as="div"
            className="xrg-topbar-user cursor-pointer d-flex align-items-center gap-2"
          >
            <FontAwesomeIcon
              icon={faUserCircle}
              className="text-secondary"
              size="lg"
            />
            <span className="fw-bold fs-12 text-secondary d-none d-sm-inline">
              Admin
            </span>
          </Dropdown.Toggle>
          <Dropdown.Menu>
            <Dropdown.Header>Admin Logged In</Dropdown.Header>
            <Dropdown.Divider />
            <Dropdown.Item onClick={handleLogout}>
              <FontAwesomeIcon
                icon={faRightFromBracket}
                className="text-danger me-2"
              />
              <span className="fw-bold fs-12">Log Out</span>
            </Dropdown.Item>
          </Dropdown.Menu>
        </Dropdown>
      </div>
    </header>
  );
}
